import { Reports_GetDevicesQuery } from '@/__generated__/graphql';
import { parseSearchTerm } from '@/utils/parseSearchTerm';
import Fuse from 'fuse.js';
import { FC, useMemo, useState } from 'react';
import { MultipleCheckbox } from './MultipleCheckbox';
import { Trans } from '@lingui/macro';

interface Props {
  data: Reports_GetDevicesQuery;
  selectedDeviceIds: string[];
  onChangeSelectedDeviceIds: (deviceIds: string[]) => void;
}

export const DevicesInput: FC<Props> = ({ data, selectedDeviceIds, onChangeSelectedDeviceIds }) => {
  const [searchDevices, setSearchDevices] = useState('');

  const filteredDeviceOptions = useMemo(() => {
    let filteredItems = data.devices
      .map(({ id, profile }) => ({
        label: `${id} - ${profile.name}`,
        value: id,
        checked: selectedDeviceIds.includes(id),
      }))
      .sort((a, b) => Number(b.checked) - Number(a.checked));

    if (searchDevices) {
      const searchObject = parseSearchTerm(searchDevices);

      if (searchObject.type === 'like') {
        const fuse = new Fuse(filteredItems, {
          keys: ['value', 'label'],
        });
        filteredItems = fuse.search(searchDevices).map(({ item }) => item);
      } else {
        filteredItems = filteredItems.filter((item) => item.value === searchObject.value);
      }
    }

    return filteredItems;
  }, [data, searchDevices, selectedDeviceIds]);

  return (
    <MultipleCheckbox
      title={<Trans>Seleccionar dispositivos</Trans>}
      options={filteredDeviceOptions}
      onToggle={(value, checked) => {
        const ids = selectedDeviceIds;
        if (!checked) {
          onChangeSelectedDeviceIds(ids.filter((id) => id !== value));
        } else {
          onChangeSelectedDeviceIds([...ids, value]);
        }
      }}
      deselectAllDisabled={selectedDeviceIds.length === 0 || Boolean(searchDevices)}
      selectAllDisabled={selectedDeviceIds.length === data.devices.length || Boolean(searchDevices)}
      onSelectAll={() => onChangeSelectedDeviceIds(data.devices.map((device) => device.id))}
      onDeselectAll={() => onChangeSelectedDeviceIds([])}
      onSearch={setSearchDevices}
      search={searchDevices}
      selectedLength={selectedDeviceIds.length}
    />
  );
};
